import request from '@/utils/request'

// 결제 내역 조회
export function getClientPaymentHistoryList(params, isNotify) {
  return request({
    url: `/api/getClientPaymentHistoryList`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}